import { SingleDonation as SingleDonationForm } from "@bgea-js/form-templates";
import "../../../../src/content/worldview-cards-donation/worldview-cards-donation.scss";
import * as React from 'react';
export default {
  SingleDonationForm,
  React
};